import React from 'react'
import PropTypes from 'prop-types'

import Rating from 'src/ui/Rating/Rating'
import { t } from 'src/lib/i18n-react'
import { Flex, Image, Box } from '@chatterbug/aaron'
import checkGreen from 'src/ui/assets/icons/checkGreen.svg'
import checkGrey from 'src/pages/UnitDetail/assets/checkGrey.svg'
import Card from 'src/ui/Card/Card'

const Footer = ({ rating }) => {
  return (
    <Flex>
      <Image src={rating >= 3 ? checkGreen : checkGrey} mr="1x" />
      <Rating rating={rating} />
    </Flex>
  )
}

const UnitExercise = ({ item, linkUrl, showExerciseRating }) => {
  const { imageUrl, name, rating, timesSeen, lastSeen } = item
  const combinedString = t(
    'Seen %{smart_count} time - %{lastSeen} |||| Seen %{smart_count} times - %{lastSeen}',
    {
      smart_count: timesSeen,
      lastSeen,
    }
  )
  const subtitleText =
    timesSeen && lastSeen ? combinedString : t('Have not seen')
  return (
    <Card
      linkUrl={linkUrl}
      imgUrl={imageUrl}
      title={
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {name}
        </Box>
      }
      aspectRatio="2:1"
      subtitle={showExerciseRating && subtitleText}
      footer={showExerciseRating && <Footer rating={rating} />}
    />
  )
}

UnitExercise.propTypes = {
  item: PropTypes.object.isRequired,
  linkUrl: PropTypes.string.isRequired,
  showExerciseRating: PropTypes.bool.isRequired,
}

export default UnitExercise
